import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import AllocationsPage from './allocations/AllocationsPage';
import ApplicationDetailPage from './applications/ApplicationDetailPage';
import ApplicationsPage from './applications/ApplicationsPage';
import ApprovalsInbox from './approvals/ApprovalsInbox';
import ApprovalsPage from './approvals/ApprovalsPage';
import AuditPage from './audit/AuditPage';
import LiveAuditPage from './audit/LiveAuditPage';
import CallDetailPage from './calls/CallDetailPage';
import CallsPage from './calls/CallsPage';
import CallWizardPage from './calls/CallWizardPage';
import CapitalReturnDetailPage from './capitalReturns/CapitalReturnDetailPage';
import CapitalReturnsPage from './capitalReturns/CapitalReturnsPage';
import CapitalReturnWizardPage from './capitalReturns/CapitalReturnWizardPage';
import CommunicationsPage from './communications/CommunicationsPage';
import AccountingExportsPage from './exports/AccountingExportsPage';
import RedemptionsPage from './redemptions/RedemptionsPage';
import ChangesPage from './changes/ChangesPage';
import DashboardPage from './dashboard/DashboardPage';
import DistributionDetailPage from './distributions/DistributionDetailPage';
import DistributionsPage from './distributions/DistributionsPage';
import DistributionWizardPage from './distributions/DistributionWizardPage';
import EntitiesPage from './entities/EntitiesPage';
import EntityDetailPage from './entities/EntityDetailPage';
import SampleRecordSection from './entities/SampleRecordSection';
import FundDetailPage from './funds/FundDetailPage';
import FundsPage from './funds/FundsPage';
import LiveFundDetailPage from './funds/LiveFundDetailPage';
import LiveFundsPage from './funds/LiveFundsPage';
import HolderDetailPage from './holders/HolderDetailPage';
import HoldersPage from './holders/HoldersPage';
import KycPage from './kyc/KycPage';
import ManagerShell from './ManagerShell';
import MigrationPage from './migration/MigrationPage';
import FinancialClosePage from './offers/FinancialClosePage';
import OfferDetailPage from './offers/OfferDetailPage';
import OffersPage from './offers/OffersPage';
import LiveOfferDetailPage from './offers/LiveOfferDetailPage';
import LiveOffersPage from './offers/LiveOffersPage';
import PaymentsPage from './payments/PaymentsPage';
import RegisterPage from './register/RegisterPage';
import ReportsPage from './reports/ReportsPage';
import SettingsPage from './settings/SettingsPage';
import LiveHouseDefaultsPage from './settings/LiveHouseDefaultsPage';
import SetupHomePage from './setup/SetupHomePage';
import SetupWizardPage from './setup/SetupWizardPage';
import LiveSetupHomePage from './setup/LiveSetupHomePage';
import LiveSetupWizardPage from './setup/LiveSetupWizardPage';
import TaxPage from './tax/TaxPage';
import { useRegistrySession } from '../session/RegistrySession';

export default function ManagerRoutes() {
  const session = useRegistrySession();
  return (
    <ManagerShell>
      <Routes>
        <Route index element={<DashboardPage />} />
        <Route path="funds" element={session ? <LiveFundsPage /> : <FundsPage />} />
        <Route
          path="funds/:fundId"
          element={session ? <LiveFundDetailPage /> : <FundDetailPage />}
        />
        <Route path="register" element={<RegisterPage />} />
        <Route path="holders" element={<EntitiesPage />} />
        <Route path="holders/:entityId" element={<EntityDetailPage />} />
        <Route
          path="holders/sample"
          element={
            <SampleRecordSection>
              <HoldersPage />
            </SampleRecordSection>
          }
        />
        <Route
          path="holders/sample/:holderId"
          element={
            <SampleRecordSection>
              <HolderDetailPage />
            </SampleRecordSection>
          }
        />
        <Route path="allocations" element={<AllocationsPage />} />
        <Route path="applications" element={<ApplicationsPage />} />
        <Route path="applications/:applicationId" element={<ApplicationDetailPage />} />
        <Route path="offers" element={session ? <LiveOffersPage /> : <OffersPage />} />
        <Route
          path="offers/:offerId"
          element={session ? <LiveOfferDetailPage /> : <OfferDetailPage />}
        />
        <Route path="offers/:offerId/close" element={<FinancialClosePage />} />
        <Route path="setup" element={session ? <LiveSetupHomePage /> : <SetupHomePage />} />
        <Route
          path="setup/:setupId"
          element={session ? <LiveSetupWizardPage /> : <SetupWizardPage />}
        />
        <Route path="kyc" element={<KycPage />} />
        <Route path="calls" element={<CallsPage />} />
        <Route path="calls/new" element={<CallWizardPage />} />
        <Route path="calls/:callId" element={<CallDetailPage />} />
        <Route path="distributions" element={<DistributionsPage />} />
        <Route path="distributions/new" element={<DistributionWizardPage />} />
        <Route path="distributions/:distributionId" element={<DistributionDetailPage />} />
        <Route path="capital-returns" element={<CapitalReturnsPage />} />
        <Route path="capital-returns/new" element={<CapitalReturnWizardPage />} />
        <Route path="capital-returns/:capitalReturnId" element={<CapitalReturnDetailPage />} />
        <Route path="redemptions" element={<RedemptionsPage />} />
        <Route path="communications" element={<CommunicationsPage />} />
        <Route path="exports" element={<AccountingExportsPage />} />
        <Route path="payments" element={<PaymentsPage />} />
        <Route
          path="approvals"
          element={session ? <ApprovalsInbox session={session} /> : <ApprovalsPage />}
        />
        {session && <Route path="approvals/prototype" element={<ApprovalsPage />} />}
        <Route path="changes" element={<ChangesPage />} />
        <Route path="tax" element={<TaxPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="audit" element={session ? <LiveAuditPage /> : <AuditPage />} />
        <Route path="migration" element={<MigrationPage />} />
        <Route path="settings" element={session ? <LiveHouseDefaultsPage /> : <SettingsPage />} />
        <Route path="*" element={<Navigate to="/manager" replace />} />
      </Routes>
    </ManagerShell>
  );
}
